import React, {useContext} from "react";
import './ClientInvoice3.css';
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";
import Invoice3Header from "./Invoice3Header";
import CompanyBranchAndEstimateInfo from "./CompanyBranchAndEstimateInfo";
import ClientInfo from "./ClientInfo";
import EstimateAddress from "./EstimateAddress";
import NcBolImportantSections from "./NcBolImportantSections";
import NcBolChargesSection from "./NcBolChargesSection";
import DefaultModal from "../CommonComponents/DefaultModal";
import DefaultAlerts from "../CommonComponents/DefaultAlerts";

export default () => {
    let Record = useContext(RecordsManagementContext);
    let IV3_PageDetails = Record.IV3_PageDetails || {};
    let companyInfo = IV3_PageDetails.CompanyBranchAndEstimateInfo || {};
    let backgroundColor1 = companyInfo.BgColor1 || '#172b4d';
    let backgroundColor2 = companyInfo.BgColor2 || '#1d4d6e';

    return (
        <div style={{backgroundColor: '#172b4d', backgroundImage: `linear-gradient(45deg, ${backgroundColor1} 15%, ${backgroundColor2} 85%)`}}>
            <div className='width-wrapper'>
                <DefaultAlerts/>
            </div>
            <div className='width-wrapper px-4'>
                <table className="table invoice3-main-table">
                    <thead className='is-sticky invoice3-sticky-head'>
                    <tr>
                        <th className="td-main-bost wid-sticky invoice3-header-cell" colSpan="2">
                            <Invoice3Header/>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="td-main-bost invoice3-body-top" colSpan="2">
                            <CompanyBranchAndEstimateInfo/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost" colSpan="2">
                            <ClientInfo/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost" colSpan="2">
                            <EstimateAddress/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost" colSpan="2">
                            <NcBolImportantSections/>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost" colSpan="2">
                            <NcBolChargesSection/>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <DefaultModal/>
            </div>
        </div>
    );
};
